export const fieldList = {
  columnKeys() {
    switch (this.lotteryType) {
      case 'pk10':
        return (new Array(10)).fill().map((nothing, index) => {
          let columnLabel
          if (index === 0) columnLabel = '冠军'
          else if (index === 1) columnLabel = '亚军'
          else {
            switch (index) {
              case 2:
                columnLabel = '第三名'
                break
              case 3:
                columnLabel = '第四名'
                break
              case 4:
                columnLabel = '第五名'
                break
              case 5:
                columnLabel = '第六名'
                break
              case 6:
                columnLabel = '第七名'
                break
              case 7:
                columnLabel = '第八名'
                break
              case 8:
                columnLabel = '第九名'
                break
              case 9:
                columnLabel = '第十名'
                break
              case 10:
                columnLabel = '第十名'
                break
            }
          }
          return {
            columnLabel,
            key: `hm${index + 1}`,
            colSpan: 4
          }
        })
      case 'ssc':
        return (new Array(5)).fill().map((nothing, index) => {
          let columnLabel
          switch (index) {
            case 0:
              columnLabel = '第一球'
              break
            case 1:
              columnLabel = '第二球'
              break
            case 2:
              columnLabel = '第三球'
              break
            case 3:
              columnLabel = '第四球'
              break
            case 4:
              columnLabel = '第五球'
              break
          }
          return {
            columnLabel,
            key: `hm${index + 1}`,
            colSpan: 4
          }
        })
      case '11x5':
        return (new Array(5)).fill().map((nothing, index) => {
          let columnLabel
          switch (index) {
            case 0:
              columnLabel = '第一球'
              break
            case 1:
              columnLabel = '第二球'
              break
            case 2:
              columnLabel = '第三球'
              break
            case 3:
              columnLabel = '第四球'
              break
            case 4:
              columnLabel = '第五球'
              break
          }
          return {
            columnLabel,
            key: `hm${index + 1}`,
            colSpan: 4
          }
        })
      case 'kl10':
        return (new Array(8)).fill().map((nothing, index) => {
          let columnLabel
          switch (index) {
            case 0:
              columnLabel = '第一球'
              break
            case 1:
              columnLabel = '第二球'
              break
            case 2:
              columnLabel = '第三球'
              break
            case 3:
              columnLabel = '第四球'
              break
            case 4:
              columnLabel = '第五球'
              break
            case 5:
              columnLabel = '第六球'
              break
            case 6:
              columnLabel = '第七球'
              break
            case 7:
              columnLabel = '第八球'
              break
          }
          return {
            columnLabel,
            key: `hm${index + 1}`,
            colSpan: 4
          }
        })
      // case 'k3':
      //   return (new Array(3)).fill().map((nothing, index) => ({ key: `hm${index + 1}` }))
      default:
        console.warn('hmList: 透過lotteryType 取得對應的號碼列表失敗! 將使用空陣列.', this.lotteryType)
        return []
    }
  },
  subColKeys() {
    return [
      { label: '大', key: 'daxiao_da' },
      { label: '小', key: 'daxiao_xiao' },
      { label: '单', key: 'danshuang_dan' },
      { label: '双', key: 'danshuang_shuang' }
    ]
  }
}

